import '@ant-design/v5-patch-for-react-19';
import 'antd/dist/reset.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const AppContent = () => {
  return process.env.NODE_ENV !== 'production' ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  );
};

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<AppContent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
